export const internalScreens = {
  credit: '/wayni-credito',
  credit_interest_free_advance: '/pedir-adelanto/sin-interes',
  credit_advance: '/pedir-adelanto',
  help_center: '/centro-de-ayuda',
  help_center_contact: '/centro-de-ayuda/contactanos',
  help_center_faq: '/centro-de-ayuda/preguntas-frecuentes',
  membership_hub: '/suscripcion',
  cards: '/mis-tarjetas',
  credit_profile: '/perfil-crediticio',
  cash_out: '/transferencias'
}
